module.exports = "http://cdn.realive.com.ua/src/views/donate/main/elements/shop/img/p_1.svg";